import { useEffect } from 'react';

import { useHistorySnapshot } from 'components/Iframe/useHistorySnapshot';
import { useRef } from 'react';
import { parseSearchParams } from 'components/Iframe/parseSearchParams';

interface Props {
  url: URL;
  search: URLSearchParams;
}

export function useSendUpdateParamsToIframe(props: Props) {
  const { url, search } = props;
  const urlRef = useRef(url.toString());
  const { iframeRef } = useHistorySnapshot({ iframeSrc: urlRef.current });

  useEffect(() => {
    iframeRef.current?.contentWindow?.postMessage({
      type: 'UPDATE_PARAMS',
      params: parseSearchParams(search),
    });
  }, [search.toString()]);

  return {
    iframeRef,
  };
}
